export const formatGender = (input: string): string | null => {
  if (input === "M" || input === "Male") {
    return "Male";
  } else if (input === "F" || input === "Female") {
    return "Female";
  } else {
    return null;
  }
};
